import { all } from "redux-saga/effects";

import { 
    loadCreateMajor,
    loadDeleteMajor,
    loadEditMajor,
    loadMajor,
    loadMajors,
    loadClasses,
} from './major';

import {
    loadProgrammes,
    loadProgramme,
    loadAddProgramme,
    loadDeleteProgramme,
    loadEditProgramme,
    loadProgrammeCourses,
} from './programme';

import {
    loadCourse,
    loadCourses,
    loadAddCourse,
    loadDeleteCourse,
    loadEditCourse,
    loadFilterCourse,
    loadAddStudentToCourse,
    loadStudentCourse,
    loadStudentOfCourse,
    loadDeleteStudentCourse,
    loadRemainStudentOfCourse,
    loadCoursesByTeacher,
} from './course';

import {
    loadModule,
    loadModules,
    loadModulesByIdCourse,
    loadAddModule,
    loadDeleteModule,
    loadChangeModule,
    loadEditModule,
    loadFilterModule,
    loadModulesByIdCourse2,
    loadModulesTeacherByIdCourse,
} from './part';

import {
    loadThematic,
    loadThematics,
    loadThematicsByIdModule,
    loadAddThematic,
    loadDeleteThematic,
    loadEditThematic,
    loadFilterThematic,
    loadThematicsByTeacher,
} from './thematic';

import { 
    loadLesson,
    loadLessonById,
    loadLessons,
    loadAddLesson,
    loadDeleteLesson,
    loadEditLesson,
    loadFilter,
} from './lesson';

import { 
    loadUserStaff,
    loadUserStudent,
    loadUserTeacher,
    loadUsers,
    loadStudents,
    loadTeachers,
    loadStaffs,
    loadDeleteUser,
    loadDeleteUsers,
    loadEditUser,
    loadEditStaff,
    loadEditStudent,
    loadEditTeacher,
    loadCreateUser,
    loadCreateStaff,
    loadCreateStudent,
    loadCreateTeacher,
    loadLogin,
    loadLogout,
    loadVerify,
    loadRegister,
    loadDeleteTeacher,
    loadDeleteStaff,
    loadDeleteStudent,
    loadDeleteStudent2,
    loadChagePassword,
    loadRankUser,
    loadRankUser2,
    loadForgotPassword,
    loadRegisterContest,
} from './user';

import { 
    loadAddExam,
    loadDeleteExam,
    loadEditExam,
    loadEditExamDGNLUser,
    loadEditExamDGTDUser,
    loadExam,
    loadExams,
    loadFilterExam,
    loadFilterExamDGNL,
    loadCriteriaDGNLByCourse,
    loadCriteriaByCourse,
    loadModuleCriteria,
    loadSyntheticCritera,
    loadThematicCriteria,
    loadPublishExam,
    loadGoUsing,
    loadCombineExam,
    loadExamCourse,
    loadCreateExamUser,
    loadDeleteExamUser,
    loadEditExamUser,
    loadExamUser,
    loadExamsUser,
    loadExamsUserV2,
    loadReuseExam,
    loadExamCourseOnline,
    loadCriteriaDGTDByCourse,
    loadExamSynthetic,
    loadExamSyntheticModule,
    loadExamSyntheticThematic,
    loadStatisticTeacher,
    loadStudentsByTeacher,
} from './exam';

import { 
    loadAddTypeExam,
    loadDeleteTypeExam,
    loadEditTypeExam,
    loadTypeExam,
    loadTypeExams,
} from './typeExam'

import { 
    loadAddQuestion,
    loadDeleteQuestion,
    loadEditQuestion,
    loadFilterQuestion,
    loadQuestion,
    loadQuestions,
    loadGetQuestionsByExam,
    loadAddQuestionExam,
    loadDeleteQuestionExam,
    loadGetQuestionExam,
    loadGetQuestionsExam,
    loadAddDetailQuestion,
    loadDeleteDetailQuestion,
    loadDetailsQuestion,
    loadEditDetailQuestion,
    loadEditQuestionExam,
} from './question';

import { 
    loadAdAnswer,
    loadAnswer,
    loadAnswers,
    loadDeleteAnswer,
    loadEditAnswer,
    loadFilterAnswer,
    loadAnswerUser,
    loadAnswersUser,
    loadCreateAnswerUser,
    loadDeleteAnswerUser,
    loadEditAnswerUser,
    loadDeleteAnswerByQuestion,
} from './answer';

import { 
    loadAdExceprt,
    loadDeleteExceprt,
    loadEditExceprt,
    loadExceprt,
    loadExceprts,
    loadFilterExceprt
} from './exceprt';

import { 
    loadAddCriteriaCourse,
    loadAddCriteriaModule,
    loadAddCriteriaThematic,
    loadCriteriaCourse,
    loadCriteriaModule,
    // loadCriteriaThematic,
    loadCriteriasCourse,
    loadCriteriasModule,
    loadCriteriasThematic,
    loadDeleteCriteriaCourse,
    loadDeleteCriteriaModule,
    loadDeleteCriteriaThematic,
    loadEditCriteriaCourse,
    loadEditCriteriaModule,
    loadEditCriteriaThematic,
    loadCriteriaByThematic,
    loadCriteriaThematic,
    loadCriteriaByModule,
    loadAddCriteriaOnline,
    loadCriteriaOnline,
    loadCriteriasOnline,
    loadDeleteCriteriaOnline,
    loadEditCriteriaOnline,
    loadAddCriteriaDGNL,
    loadCriteriaDGNL,
    loadCriteriasDGNL,
    loadDeleteCriteriaDGNL,
    loadEditCriteriaDGNL,
    loadCriteriasDGTD,
    loadEditCriteriaDGTD,
    loadCriteriaDGTD,
    loadAddCriteriaDGTD,
    loadDeleteCriteriaDGTD,
    loadCheckCriteria,
} from './criteria';

import {
    loadAddAdsCourse,
    loadAddAdsDoc,
    loadAddAdsTeacher,
    loadAdsCourse,
    loadAdsCourses,
    loadAdsDoc,
    loadAdsDocs,
    loadAdsTeacher,
    loadAdsTeachers,
    loadChangeStatusAdsCourse,
    loadChangeStatusAdsDoc,
    loadChangeStatusAdsTeacher,
    loadDeleteAdsCourse,
    loadDeleteAdsDoc,
    loadDeleteAdsTeacher,
    loadEditAdsCourse,
    loadEditAdsDoc,
    loadEditAdsTeacher,
} from './advertisement';

import {  
    loadAddDoc,
    loadChangeStatusDoc,
    loadDeleteDoc,
    loadDoc,
    loadDocs,
    loadEditDoc,
} from './document';

import { 
    loadAddMenu,
    loadDeleteMenu,
    loadEditMenu,
    loadFilterMenu,
    loadMenu,
    loadMenus,
} from './menu';

import { 
    loadAddDescriptionCourse,
    loadDeleteDescriptionCourse,
    loadDescriptionCourse,
    loadDescriptionCourses,
    loadEditDescriptionCourse,
} from './descriptionCourse';

import { 
    loadAddDiscount,
    loadDeleteDiscount,
    loadChangeStatusDiscount,
    loadDiscount,
    loadDiscountByCourse,
    loadDiscounts,
    loadEditDiscount,
} from './discount';

import { 
    loadAddDealer,
    loadAddDealerDetail,
    loadChangeStatusDealer,
    loadDealer,
    loadDealer2,
    loadDealerDetail,
    loadDealers,
    loadDealersDetail,
    loadDeleteDealer,
    loadDeleteDealerDetail,
    loadEditDealer,
    loadEditDetail,
    loadCheckCodeDealer,
    loadChangeStatusDealersDetail,
    loadDeleteDealersDetail,
    loadDealersTeacher,
    loadDealersDetailTeacher,
} from './dealer'

import {    
    loadReceipts,
    loadAddReceipt,
    loadAddReceiptDetail,
    loadChangeStatusReceipt,
    loadDeleteReceipt,
    loadDeleteReceiptDetail,
    loadEditReceiptDetail,
    loadEditReceipt,
    loadReceipt,
    loadReceiptDetail,
    loadReceiptsDetail,
    loadReceiptsuser,
    loadReceiptDetailUser,
} from './receipt';

import { 
    loadAddBank,
    loadBank,
    loadBanks,
    loadDeleteBank,
    loadEditBank,
    loadFilterBank,
} from './bank';

import {
    loadAddNotification,
    loadDeleteNotification,
    loadEditNotification,
    loadFilterNotification,
    loadNotification,
    loadNotifications,
    loadChangeNotification,
    loadNotificationsUser,
} from './notification';


import {
    loadAddComment,
    loadAddSubComment,
    loadComment,
    loadComments,
    loadDeleteComment,
    loadDeleteSubComment,
    loadEditComment,
    loadEditSubComment,
    loadSubComment,
    loadSubComments,    
} from './comment';

import {
    loadAddFooter,
    loadDeleteFooter,
    loadEditFooter,
    loadFooter,
    loadFooters,
} from './footer';

import {
    loadAddContact,
    loadContact,
    loadContacts,
    loadDeleteContact,
    loadEditContact,
} from './contact';

import {
    loadEvaluations,
    loadEvaluationDGNL,
    loadEvaluationsDGNL,
    loadAddEvaluationDGNL,
    loadEditEvaluationDGNL,
    loadDeleteEvaluationDGNL,
    loadAddEvaluation,
    loadDeleteEvaluation,
    loadEditEvaluation,
    loadEvaluation,
    loadAddEvaluationDGTD,
    loadDeleteEvaluationDGTD,
    loadEditEvaluationDGTD,
    loadEvaluationDGTD,
    loadEvaluationsDGTD,
} from './evaluate';

import {
    loadAddOptionQuestion,
    loadDeleteOptionQuestion,
    loadEditOptionQuestion,
    loadOptionQuestion,
} from './optionQuestion';

import {
    loadDeleteSetExam,
    loadSetExam,
    loadUploadSetExam,
    loadDeleteFileSetExam,
    loadAddUserToSetExam,
    loadUserSetExam,
    loadUsersOfSetExam,
    loadDeleteUserSetExam,
} from './setExam';

import {
    loadAddPosition,
    loadDeletePosition,
    loadEditPosition,
    loadPosition,
    loadPositions,
    loadPermissions,
} from './position';

export default function* rootSaga() {
    yield all([
        // major
        loadCreateMajor(),
        loadDeleteMajor(),
        loadEditMajor(),
        loadMajor(),
        loadMajors(),
        loadClasses(),
        // programme
        loadProgrammes(),
        loadProgramme(),
        loadAddProgramme(),
        loadDeleteProgramme(),
        loadEditProgramme(),
        loadProgrammeCourses(),
        // course
        loadCourse(),
        loadCourses(),
        loadAddCourse(),
        loadEditCourse(),
        loadDeleteCourse(),
        loadFilterCourse(),
        loadAddStudentToCourse(),
        loadStudentCourse(),
        loadStudentOfCourse(),
        loadDeleteStudentCourse(),
        loadRemainStudentOfCourse(),
        loadCoursesByTeacher(),
        // module
        loadModule(),
        loadModules(),
        loadModulesByIdCourse(),
        loadAddModule(),
        loadDeleteModule(),
        loadChangeModule(),
        loadEditModule(),
        loadFilterModule(),
        loadModulesByIdCourse2(),
        loadModulesTeacherByIdCourse(),
        // thematic
        loadThematic(),
        loadThematics(),
        loadThematicsByTeacher(),
        loadThematicsByIdModule(),
        loadAddThematic(),
        loadDeleteThematic(),
        loadEditThematic(),
        loadFilterThematic(),
        // lesson
        loadLesson(),
        loadLessonById(),
        loadLessons(),
        loadAddLesson(),
        loadDeleteLesson(),
        loadEditLesson(),
        loadFilter(),
        // user
        loadUserStaff(),
        loadUserStudent(),
        loadUserTeacher(),
        loadUsers(),
        loadStudents(),
        loadStaffs(),
        loadTeachers(),
        loadDeleteUser(),
        loadDeleteUsers(),
        loadEditUser(),
        loadEditStaff(),
        loadEditStudent(),
        loadEditTeacher(),
        loadCreateUser(),
        loadCreateStaff(),
        loadCreateStudent(),
        loadCreateTeacher(),
        loadLogin(),
        loadLogout(),
        loadVerify(),
        loadRegister(),
        loadDeleteTeacher(),
        loadDeleteStaff(),
        loadDeleteStudent(),
        loadDeleteStudent2(),
        loadChagePassword(),
        loadRankUser(),
        loadRankUser2(),
        loadForgotPassword(),
        loadRegisterContest(),
        // exam
        loadAddExam(),
        loadDeleteExam(),
        loadEditExam(),
        loadEditExamDGNLUser(),
        loadEditExamDGTDUser(),
        loadExam(),
        loadExams(),
        loadFilterExam(),
        loadFilterExamDGNL(),
        loadCriteriaDGNLByCourse(),
        loadCriteriaByCourse(),
        loadModuleCriteria(),
        loadSyntheticCritera(),
        loadThematicCriteria(),
        loadCombineExam(),
        loadExamCourse(),
        loadGoUsing(),
        loadCreateExamUser(),
        loadDeleteExamUser(),
        loadEditExamUser(),
        loadExamUser(),
        loadExamsUser(),
        loadExamsUserV2(),
        loadReuseExam(),
        loadExamCourseOnline(),
        loadCriteriaDGTDByCourse(),
        loadExamSynthetic(),
        loadExamSyntheticModule(),
        loadExamSyntheticThematic(),
        loadStatisticTeacher(),
        loadStudentsByTeacher(),
        // type Exam
        loadAddTypeExam(),
        loadDeleteTypeExam(),
        loadEditTypeExam(),
        loadTypeExam(),
        loadTypeExams(),
        loadPublishExam(),
        // question
        loadAddQuestion(),
        loadDeleteQuestion(),
        loadEditQuestion(),
        loadFilterQuestion(),
        loadQuestion(),
        loadQuestions(),
        loadGetQuestionsByExam(),
        loadAddQuestionExam(),
        loadDeleteQuestionExam(),
        loadGetQuestionExam(),
        loadGetQuestionsExam(),
        loadAddDetailQuestion(),
        loadDeleteDetailQuestion(),
        loadDetailsQuestion(),
        loadEditDetailQuestion(),
        loadEditQuestionExam(),
        // answer
        loadAdAnswer(),
        loadAnswer(),
        loadAnswers(),
        loadDeleteAnswer(),
        loadEditAnswer(),
        loadFilterAnswer(),
        loadAnswerUser(),
        loadAnswersUser(),
        loadCreateAnswerUser(),
        loadDeleteAnswerUser(),
        loadEditAnswerUser(),
        loadDeleteAnswerByQuestion(),
        // exceprt
        loadAdExceprt(),
        loadDeleteExceprt(),
        loadEditExceprt(),
        loadExceprt(),
        loadExceprts(),
        loadFilterExceprt(),
        // criteria
        loadAddCriteriaCourse(),
        loadAddCriteriaModule(),
        loadAddCriteriaThematic(),
        loadCriteriaCourse(),
        loadCriteriaModule(),
        loadCriteriasCourse(),
        loadCriteriasModule(),
        loadCriteriasThematic(),
        loadDeleteCriteriaCourse(),
        loadDeleteCriteriaModule(),
        loadDeleteCriteriaThematic(),
        loadEditCriteriaCourse(),
        loadEditCriteriaModule(),
        loadEditCriteriaThematic(),
        loadCriteriaByThematic(),
        loadCriteriaThematic(),
        loadCriteriaByModule(),
        loadAddCriteriaOnline(),
        loadCriteriaOnline(),
        loadCriteriasOnline(),
        loadDeleteCriteriaOnline(),
        loadEditCriteriaOnline(),
        loadAddCriteriaDGNL(),
        loadCriteriaDGNL(),
        loadCriteriasDGNL(),
        loadDeleteCriteriaDGNL(),
        loadEditCriteriaDGNL(),
        loadCriteriaDGTD(),
        loadCriteriasDGTD(),
        loadAddCriteriaDGTD(),
        loadEditCriteriaDGTD(),
        loadDeleteCriteriaDGTD(),
        loadCheckCriteria(),
        // advertisement
        loadAddAdsCourse(),
        loadAddAdsDoc(),
        loadAddAdsTeacher(),
        loadAdsCourse(),
        loadAdsCourses(),
        loadAdsDoc(),
        loadAdsDocs(),
        loadAdsTeacher(),
        loadAdsTeachers(),
        loadChangeStatusAdsCourse(),
        loadChangeStatusAdsDoc(),
        loadChangeStatusAdsTeacher(),
        loadDeleteAdsCourse(),
        loadDeleteAdsDoc(),
        loadDeleteAdsTeacher(),
        loadEditAdsCourse(),
        loadEditAdsDoc(),
        loadEditAdsTeacher(),
        // Document
        loadAddDoc(),
        loadChangeStatusDoc(),
        loadDeleteDoc(),
        loadDoc(),
        loadDocs(),
        loadEditDoc(),
        // menu
        loadAddMenu(),
        loadDeleteMenu(),
        loadEditMenu(),
        loadFilterMenu(),
        loadMenu(),
        loadMenus(),
        // description course
        loadAddDescriptionCourse(),
        loadDeleteDescriptionCourse(),
        loadDescriptionCourse(),
        loadDescriptionCourses(),
        loadEditDescriptionCourse(),
        // discount
        loadAddDiscount(),
        loadDeleteDiscount(),
        loadChangeStatusDiscount(),
        loadDiscount(),
        loadDiscountByCourse(),
        loadDiscounts(),
        loadEditDiscount(),
        // dealer
        loadAddDealer(),
        loadAddDealerDetail(),
        loadChangeStatusDealer(),
        loadDealer(),
        loadDealer2(),
        loadDealerDetail(),
        loadDealers(),
        loadDealersDetail(),
        loadDeleteDealer(),
        loadDeleteDealerDetail(),
        loadEditDealer(),
        loadEditDetail(),
        loadChangeStatusDealersDetail(),
        loadDeleteDealersDetail(),
        loadDealersTeacher(),
        loadDealersDetailTeacher(),
        // receipt
        loadReceipts(),
        loadAddReceipt(),
        loadAddReceiptDetail(),
        loadChangeStatusReceipt(),
        loadDeleteReceipt(),
        loadDeleteReceiptDetail(),
        loadEditReceiptDetail(),
        loadEditReceipt(),
        loadReceipt(),
        loadReceiptDetail(),
        loadReceiptsDetail(),
        loadCheckCodeDealer(),
        loadReceiptsuser(),
        loadReceiptDetailUser(),
        // bank
        loadAddBank(),
        loadBank(),
        loadBanks(),
        loadDeleteBank(),
        loadEditBank(),
        loadFilterBank(),
        // notification
        loadAddNotification(),
        loadDeleteNotification(),
        loadEditNotification(),
        loadFilterNotification(),
        loadNotification(),
        loadNotifications(),
        loadChangeNotification(),
        loadNotificationsUser(),

        // comment
        loadAddComment(),
        loadAddSubComment(),
        loadComment(),
        loadComments(),
        loadDeleteComment(),
        loadDeleteSubComment(),
        loadEditComment(),
        loadEditSubComment(),
        loadSubComment(),
        loadSubComments(),    
        // footer
        loadAddFooter(),
        loadDeleteFooter(),
        loadEditFooter(),
        loadFooter(),
        loadFooters(),
        // contact
        loadAddContact(),
        loadContact(),
        loadContacts(),
        loadDeleteContact(),
        loadEditContact(),
        // đánh giá
        loadEvaluations(),
        loadEvaluationDGNL(),
        loadEvaluationsDGNL(),
        loadDeleteEvaluationDGNL(),
        loadAddEvaluationDGNL(),
        loadEditEvaluationDGNL(),
        loadAddEvaluation(),
        loadDeleteEvaluation(),
        loadEditEvaluation(),
        loadEvaluation(),
        loadAddEvaluationDGTD(),
        loadDeleteEvaluationDGTD(),
        loadEditEvaluationDGTD(),
        loadEvaluationDGTD(),
        loadEvaluationsDGTD(),
        // Lựa chọn câu hỏi
        loadAddOptionQuestion(),
        loadDeleteOptionQuestion(),
        loadEditOptionQuestion(),
        loadOptionQuestion(),
        // Bộ đề thi
        loadDeleteFileSetExam(),
        loadDeleteSetExam(),
        loadSetExam(),
        loadUploadSetExam(),
        loadAddUserToSetExam(),
        loadUserSetExam(),
        loadUsersOfSetExam(),
        loadDeleteUserSetExam(),
        // chức vụ
        loadAddPosition(),
        loadDeletePosition(),
        loadEditPosition(),
        loadPosition(),
        loadPositions(),
        loadPermissions(),
    ]);
}